export function normalizeRoadPhysicalAddress(value) {
  if (value == null || (typeof value === 'string' && value.trim() === '')) return 0
  if (!['number', 'string'].includes(typeof value) || !/^\d+$/.test(String(value))
    || !Number.isSafeInteger(Number(value)) || Number(value) > 2147483647) {
    throw new Error('machineRoadInvalidPhysics')
  }
  return Number(value)
}

export function effectiveRoadAddress(row) {
  try {
    return normalizeRoadPhysicalAddress(row.physics) || row.number
  } catch (_error) {
    return '—'
  }
}

export function importRoadPhysicalAddress(value, locationType) {
  const address = normalizeRoadPhysicalAddress(value)
  // Preserve the sentinel so it continues to follow the imported road number.
  return address > 0
    ? normalizeRoadPhysicalAddress(address + (Number(locationType || 1) - 1) * 1000)
    : 0
}
